// import ReactDOM from "react-dom";
import React from "react";
import { BrowserRouter } from "react-router-dom";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { AuthProvider } from "./hooks/useAuth";
import { TokenProvider } from "./context/TokenContext";
// import { createRoot } from "react-dom/client";
import * as ReactDOMClient from 'react-dom/client';

import App from "./App";
import SnackbarProvider from "./hooks/SnackbarProvider";
import { initializeSecureStorage } from "./utils/storageInit";

// ✅ CRITICAL: Initialize secure storage BEFORE React renders
// This migrates data from localStorage to sessionStorage synchronously
// so that AuthProvider can read the migrated data on first render
initializeSecureStorage();

// Create React Query client with optimized defaults
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // Data stays fresh for 5 minutes
      cacheTime: 10 * 60 * 1000, // Cache persists for 10 minutes
      refetchOnWindowFocus: false, // Don't refetch on window focus
      retry: 1, // Retry failed requests once
      refetchOnReconnect: true, // Refetch on reconnect
    },
  },
});

//  const rootElement = document.getElementById('root');
// const root = createRoot(document.getElementById('root'));


const rootElement = document.getElementById("root");

const root = ReactDOMClient.createRoot(rootElement);

const theme = createTheme({
  palette: {
    primary: { main: "#3a34d2" }
  }
});

root.render(
  // </React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <TokenProvider>
          <SnackbarProvider>
            <AuthProvider>
              <ThemeProvider theme={theme}>
                <App />
              </ThemeProvider>
            </AuthProvider>
          </SnackbarProvider>
        </TokenProvider>
      </BrowserRouter>
      {/* React Query Devtools - only shows in development */}
      <ReactQueryDevtools initialIsOpen={false} position="bottom-right" />
    </QueryClientProvider>
  // </React.StrictMode>
  );



// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
